module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":"An error occurred","success":"Success!","at":"At"},"nl":{"error":"Er is iets mis gegaan","success":"Gelukt!","at":"Op"}}')
  delete Component.options._Ctor
}
